import { render, staticRenderFns } from "./DynamicRows.vue?vue&type=template&id=53113e2e&scoped=true"
import script from "./DynamicRows.vue?vue&type=script&lang=js"
export * from "./DynamicRows.vue?vue&type=script&lang=js"
import style0 from "./DynamicRows.vue?vue&type=style&index=0&id=53113e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53113e2e",
  null
  
)

export default component.exports